define([
	'jquery',
	'domReady',
	'pubsub'
], function ($, domReady) {

	if (WCS_CONFIG.get('ANALYTICS::gtmEnabled')) {
		var isPackItPage = false,
			productBlockList = '#catalog-container .product-block-js',
			productBlockClass = '.product-block-js',
			totalProducts = 0;

		domReady(function () {
			isPackItPage = $('#pack-it').length == 1;
			if (isPackItPage) {
				productBlockList = '.product-finder-results .product-panel-js';
				productBlockClass = '.product-panel-js';
			}

			var parameters = getParameters(),
				products = getProducts(0, parameters);

			if (products.length > 0) {
				productImpression(products);
			}

			$(".product-listing-js").on("click", ".product-block-js .view-js, .product-block-js .name-js, .product-block-js .more-color-js, .product-panel--details-title", function (e) {
				var $productBlock = $(e.target).parents(productBlockClass);

				var productData = $productBlock.data("productData");

				parameters.productId = $productBlock.data("partNumber");
				parameters.productName = $productBlock.data("catentryNameDl");
				parameters.bundleID = $productBlock.data("bundleIdDl");
				parameters.unitPrice = getProductPrice($productBlock);
				parameters.productLine = $productBlock.data("productLine");
				parameters.recipeId = $productBlock.data("customsRecipeId");

				if (productData) {
					parameters.styleCode = productData.styleCode;
					parameters.colorCode = productData.colorCode;
					parameters.colorDescription = productData.colorDescription;
				}

				productClick(parameters);
			});
		});

		$.pubsub('subscribe', 'vfdp.wcs.product_list.ajax_product_load', function(message, data) {
			if(data) {
				try {
					var analyticsParams = {'event': 'ajax product load', 'loaded': data.beginIndex};
					window.dataLayer.push(analyticsParams);
				} catch(err) {
					console.error('Failed push to dataLayer', err);
				}
			}
		});

		$.pubsub('subscribe', 'vfdp.wcs.product_list.ajax_product_loaded', function(message, data) {
			if(data) {
				try {
					var pageId = $(".product-listing-js").data("pageId"),
						categoryId = $(".product-listing-js").data("categoryIdentifier"),
						parameters = {
							pageId: pageId ? pageId : "not set",
							categoryId: categoryId ? categoryId : 0
						},
						products = getProducts(data.gridOffset, parameters);

					if (products.length > 0){
						productImpression(products);
					}

				} catch(err) {
					console.error('Failed push to dataLayer', err);
				}
			}
		});

		$.pubsub('subscribe', 'vfdp.wcs.bundle_details_page_loaded', function (e) {
			try {
				var $bundleGroup = $(".stl-products-container"),
					$bundleItems = $bundleGroup.find(".bdp-stl-product-container"),
					$productBlock = {},
					product = {},
					productsList = [];

				$($bundleItems).each(function( index ) {
					$productBlock = $bundleItems.eq(index);
					product = $productBlock.data("productData");
					product.unitPrice = getProductPrice($productBlock);
					product.position = index + 1;
					productsList.push(product);
				});

				if (productsList.length > 0){
					productImpressionSTL(productsList);
				}

			} catch(err) {
				console.error('Failed push to dataLayer', err);
			}
		});

		$.pubsub('subscribe', 'vfdp.wcs.bundle_details_page.product.clicked', function (name, e) {
			try {
				var $bundleItems = $(e.target).parents(".bdp-stl-product-container"),
					productData = $bundleItems.data("productData"),
					parameters = {};

				parameters.pageId = productData.list;
				parameters.productId = productData.productID;
				parameters.productName = productData.name;
				parameters.bundleID = productData.bundleID;
				parameters.unitPrice = getProductPrice($bundleItems);
				parameters.productLine = productData.productLine;
				parameters.recipeId = productData.recipeId;
				parameters.styleCode = productData.styleCode;
				parameters.colorCode = productData.colorCode;
				parameters.colorDescription = productData.colorDescription;
				productClick(parameters);

			} catch(err) {
				console.error('Failed push to dataLayer', err);
			}
		});

		$.pubsub('subscribe', 'vfdp.productFinderResults.AJAX.loadMore.complete', function (name, data) {
			var productSlides = data.productSlides,
					parameters = getParameters(),
					products = [];
			if (productSlides) {
				$.each(productSlides, function (i, slide) {
					var $productBlock = $(slide).find(productBlockClass);
					totalProducts = totalProducts + 1;
					if($productBlock.length) {
						var product = getProductData($productBlock, parameters, totalProducts);
						products.push(product);
					}
				});
			}

			if (products.length > 0) {
				productImpression(products);
			}
		});

		if (WCS_CONFIG.get('grid::productListFilterTrackingEnabled')) {
			$.pubsub('subscribe', 'vfdp.wcs.product_list.FILTERS_CHANGED', function (e, data) {
				var customVariables = {
					'filterCategory': data.filterCategories,
					'filterValue': data.filterValues
				};
				addFilterTracking('Filter', data.eventLabel, customVariables);
			});

			$.pubsub('subscribe', 'vfdp.wcs.product_list.RESET_FILTERS_CLICKED', function (e) {
				addFilterTracking('Filter', 'Clear All', {});
			});

			$.pubsub('subscribe', 'vfdp.wcs.product_list.SORTING_CHANGED', function (e, sortLabel) {
				addFilterTracking('Sort by', sortLabel, {});
			});
		}
	}

	function getProductData($productBlock, parameters, pos) {
		var zmProduct = {
			productID: $productBlock.data("partNumber"),
			name: $productBlock.data("catentryNameDl"),
			bundleID: $productBlock.data("bundleIdDl"),
			unitPrice: getProductPrice($productBlock),
			badge: $productBlock.find('.product-block-promo-badge').data("badgeDesc"),
			productLine: $productBlock.data("productLine"),
			recipeId: $productBlock.data("customsRecipeId"),
			list: parameters.pageId,
			category: parameters.categoryId ? parameters.categoryId : "Misc",
			position: pos
		};

		var productData = $productBlock.data("productData");
		if (productData) {
			zmProduct.styleCode = productData.styleCode;
			zmProduct.colorCode = productData.colorCode;
			zmProduct.colorDescription = productData.colorDescription;
		}
		return zmProduct;
	}

	function getParameters() {
		var pageId = $(".product-listing-js").data("pageId"),
			categoryId = $(".product-listing-js").data("categoryIdentifier");

		var parameters = {
			pageId: pageId ? pageId : "not set",
			categoryId: categoryId ? categoryId : 0
		};

		return parameters;
	}

	function getProducts(gridOffset, parameters) {
		var products = [];
		//We only want to include product-blocks that are inside the #catalog-container and are visible
		var $productBlocks = $(productBlockList);
		for (var i = gridOffset;i < $productBlocks.length;i++) {
			var $productBlock = $productBlocks.eq(i);
			var zmProduct = getProductData($productBlock, parameters, i + 1);
			products.push(zmProduct);
		}

		totalProducts = products.length > 0 ? (totalProducts + (products.length)) : totalProducts;
		return products;
	}

	function getProductPrice($product) {
		var price = "0.00";
		var $priceItem = $product.find(".product-price-amount-js");
		if($priceItem.length > 0) {
			price = $priceItem.data('amount');
		}
		return parseFloat(price);
	}

	function getCurrencySymbol() {
		var currencySymbol;
		var jsonData;
		if(window.dataLayer) {
			for(var m in window.dataLayer) {
				jsonData = window.dataLayer[m];
				currencySymbol = jsonData.currencySymbol;
				if(currencySymbol){
					currencySymbol = currencySymbol.replace(/&amp;/g, '&');
					currencySymbol = $('<textarea/>').html(currencySymbol).text();
					window.dataLayer[m].currencySymbol = currencySymbol;
					break;
				}
			}
		}
		return currencySymbol ? currencySymbol : null;
	}

	function getCurrencyCode() {
		var currencyCode;
		var jsonData;
		if(window.dataLayer) {
			for(var m in window.dataLayer) {
				jsonData = window.dataLayer[m];
				currencyCode = jsonData.currency;
				break;
			}
		}
		return currencyCode ? currencyCode : null;
	}

	function productImpression(products) {
		var gtmProducts = mapProductDetails(products);

		window.dataLayer.push({
			'event': 'productImpression',
			'ecommerce': {
				'impressions': {
					'products': gtmProducts
				},
				'currencyCode': getCurrencyCode(),
				'currencySymbol': getCurrencySymbol()
			},
			'_clear': true
		});
	}

	function productImpressionSTL(products) {
		var gtmProducts = mapProductDetails(products);

		window.dataLayer.push({
			'event': 'productImpression',
			'ecommerce': {
				'impressions': gtmProducts,
				'currencyCode': getCurrencyCode(),
				'currencySymbol': getCurrencySymbol(),
			},
			'_clear': true
		});
	}

	function mapProductDetails(products) {
		var gtmProducts = [];
		for (var p in products) {
			var product = products[p],
				gtmProduct = {
					'id': product.productID,
					'sku': product.productID,
					'bundleID': product.bundleID ? product.bundleID : null,
					'productID': product.productID ? product.productID : null,
					'itemID': undefined,
					'name': product.name,
					'brand': product.brand || '',
					'category': product.category || "Misc",
					'variant': product.variant ? product.variant : '',
					'price': product.unitPrice,
					'list': product.list || '',
					'badge': product.badge ? product.badge : null,
					'productLine': product.productLine,
					'recipeId': product.recipeId,
					'position': product.position,
					'styleCode': product.styleCode,
					'colorCode': product.colorCode,
					'colorDescription': product.colorDescription
				};

			gtmProducts.push(gtmProduct);
		}
		return gtmProducts;
	}

	function productClick(parameters) {
		window.dataLayer.push({
			'event': 'productClick',
			'ecommerce': {
				'click': {
					'actionField': {
						'list': parameters.pageId,
						'action': 'click'
					},
					'products': [{
						'id': parameters.productId,
						'name': parameters.productName,
						'bundleID': parameters.bundleID ? parameters.bundleID:null,
						'productID': parameters.productId ? parameters.productId:null,
						'itemID': undefined,
						'brand': '',
						'category': parameters.categoryId ? parameters.categoryId : "Misc",
						'variant': parameters.definingAttributes ? parameters.definingAttributes : '',
						'price': parameters.unitPrice,
                        "colorDescription": parameters.colorDescription ? parameters.colorDescription : '',
                        "styleCode": parameters.styleCode ? parameters.styleCode : '',
                        "colorCode": parameters.colorCode ? parameters.colorCode : ''
					}]
				},
				'currencyCode': getCurrencyCode(),
				'currencySymbol': getCurrencySymbol()
			}
		});
	}

	function addFilterTracking(eventAction, eventLabel, customVariables) {
		window.dataLayer.push({
			'event': 'loadEventData',
			'eventCategory': 'PLP',
			'eventAction': eventAction,
			'eventLabel': eventLabel,
			'nonInteractive': false,
			'customMetrics': {},
			'customVariables': customVariables,
			'_clear': true
		});
	}
});
